const clampByte = value => Math.max(0, Math.min(255, Math.round(Number(value) || 0)))

/**
 * 将RGB/RGBW灯光通道归一为稳定、易读的颜色名称。
 * RGBW的白光按编辑器预览使用的混光比例叠加，保证卡片文案与色块观感一致；
 * 低饱和度灯光统一归类为白光，避免亮度变化导致颜色名称频繁跳动。
 */
const getLightColorName = (red, green, blue, white = 0) => {
  const whiteValue = clampByte(white)
  const channels = [
    clampByte(clampByte(red) + whiteValue),
    clampByte(clampByte(green) + Math.round((whiteValue * 242) / 255)),
    clampByte(clampByte(blue) + whiteValue)
  ]
  const maximum = Math.max(channels[0], channels[1], channels[2])
  if (maximum === 0) return ''

  const minimum = Math.min(channels[0], channels[1], channels[2])
  const delta = maximum - minimum
  const saturation = delta / maximum
  if (saturation < 0.18) return '白光'

  let hue = 0
  if (maximum === channels[0]) hue = 60 * (((channels[1] - channels[2]) / delta) % 6)
  else if (maximum === channels[1]) hue = 60 * ((channels[2] - channels[0]) / delta + 2)
  else hue = 60 * ((channels[0] - channels[1]) / delta + 4)
  hue = (hue + 360) % 360

  if (hue < 15 || hue >= 345) return '红光'
  if (hue < 45) return '橙光'
  if (hue < 75) return '黄光'
  if (hue < 165) return '绿光'
  if (hue < 195) return '青光'
  if (hue < 255) return '蓝光'
  if (hue < 285) return '紫光'
  return '品红光'
}

export { getLightColorName }
